import { useState, useEffect, useCallback } from "react";
import {
  getRemoteChannelMutes,
  setRemoteChannelMutes,
  subscribeChannelMute,
} from "../utils/gameAudio";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";

export function useGameSoundChannelMute() {
  const [state, setState] = useState(() => getRemoteChannelMutes());
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => subscribeChannelMute(setState), []);

  const updateMute = useCallback(async (patch) => {
    const previous = getRemoteChannelMutes();
    const next = {
      userMuted:
        patch.userMuted !== undefined ? !!patch.userMuted : previous.userMuted,
      adminMuted:
        patch.adminMuted !== undefined ? !!patch.adminMuted : previous.adminMuted,
    };
    setRemoteChannelMutes(next);
    setSaving(true);
    setError(null);

    try {
      const res = await fetch(`${API_BASE}/api/game-sounds/admin/mute`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
        body: JSON.stringify(patch),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setRemoteChannelMutes(previous);
        setError(data.error || "Failed to update mute");
        return false;
      }
      setRemoteChannelMutes({
        userMuted: !!data.userMuted,
        adminMuted: !!data.adminMuted,
      });
      return true;
    } catch (err) {
      console.error("update channel mute error", err);
      setRemoteChannelMutes(previous);
      setError("Failed to update mute");
      return false;
    } finally {
      setSaving(false);
    }
  }, []);

  const setUserMuted = useCallback(
    (value) => updateMute({ userMuted: !!value }),
    [updateMute]
  );

  const setAdminMuted = useCallback(
    (value) => updateMute({ adminMuted: !!value }),
    [updateMute]
  );

  return {
    userMuted: state.userMuted,
    adminMuted: state.adminMuted,
    saving,
    error,
    setUserMuted,
    setAdminMuted,
  };
}

export default useGameSoundChannelMute;
